 $(function() {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/asiakkaan-opas-kiitos/"
    };

    $("#customersGuideSendBtn").on("click", function(event) {
        if ($('#customersGuideForm')[0].checkValidity() && $('#customersGuideCheckbox').is(':checked')) {
            $("#customersGuideSendBtn").prop("disabled", true);
            $("#customersGuideSendBtn").css("background-color", "#6c757d");
        
            let email = $("#customersGuideEmail").val();
            let firstName = $("#customersGuideFirstName").val();
            let lastName = $("#customersGuideLastName").val();
            let organization = $("#customersGuideOrganization").val();
            let selectedOccupation = $("input[name='occupation']:checked").val();
            let code = "";
            if ($('#newsletterCheckbox').is(':checked')) {
                code = "newsletter";
            }

            if (selectedOccupation === "Muulla alalla") {
                selectedOccupation = `${selectedOccupation}: ${$("#occupationOther").val()}`;
            }

            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                organizationName: organization,
                additionalInformation: selectedOccupation,
                competitionName: "Customers guide",
                uri: "/fi/asiakkaan-opas/",
                languageCode: language,
                code: code,
            };

            console.log(data);

            // Disable the button to prevent multiple submissions
  

            $.ajax({
                url: Uris.jsonBookingsAdd,
                method: "POST",
                data: JSON.stringify(data)
            })
            .done(function() {
                window.location.href = Uris.nextPageUri;
            })
            .fail(function(err) {
                console.error(err);
                $("#customersGuideSendBtn").prop("disabled", false);
                $("#customersGuideSendBtn").css("background-color", "#28a745"); // Revert to active color
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        const formValid = $('#customersGuideForm')[0].checkValidity();
        const checkboxChecked = $('#customersGuideCheckbox').is(':checked');

        if (formValid && checkboxChecked) {
            // Enable button and change color
            $("#customersGuideSendBtn").prop("disabled", false);
            $("#customersGuideSendBtn").css("background-color", "#28a745"); // Change to your desired color (e.g., green)
        } else {
            // Disable button and reset color
            $("#customersGuideSendBtn").prop("disabled", true);
            $("#customersGuideSendBtn").css({
                "background-color": "#6c757d", // Change to your disabled color (e.g., grey)
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger the button state change on input and checkbox changes
    $('#customersGuideForm input, #customersGuideCheckbox').on('input change', toggleSendButtonState);



    // Initial button state check
    toggleSendButtonState();
});

